import { apiClient } from "./client";

export type AdminUserRole =
  | "admin"
  | "superadmin"
  | "user"
  | "propertyOwner"
  | "vendor"
  | "internal"
  | "dev";

export interface AdminUser {
  id: string;
  email: string;
  fullName?: string;
  phone?: string | null;
  role: AdminUserRole;
  [extraField: string]: unknown;
}

export interface AuthTokenPair {
  token: string;
  expires: string;
}

export interface AuthTokens {
  access: AuthTokenPair;
  refresh: AuthTokenPair;
}

export interface LoginResponse {
  user: AdminUser;
  tokens: AuthTokens;
}

export interface LoginRequest {
  email: string;
  password: string;
}

const LOGIN_SOURCE = "admin-dashboard";

export async function loginRequest(payload: LoginRequest): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>("/login", {
    email: payload.email,
    password: payload.password,
    source: LOGIN_SOURCE,
  });
  return data;
}

export async function logoutRequest(refreshToken: string): Promise<void> {
  await apiClient.patch("/logout", { refreshToken });
}

export function isAdminRole(role: AdminUserRole | string | undefined): boolean {
  return role === "admin" || role === "superadmin";
}
